import { render, staticRenderFns } from "./EditorCadastro.vue?vue&type=template&id=446d6054"
import script from "./EditorCadastro.vue?vue&type=script&lang=js"
export * from "./EditorCadastro.vue?vue&type=script&lang=js"
import style0 from "./EditorCadastro.vue?vue&type=style&index=0&id=446d6054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports